import { Routes, Route } from 'react-router-dom'
import Layout from '@/layout/Layout'
import Home from '@/pages/Home'
import AboutPage from '@/pages/AboutPage'
import ServicesPage from '@/pages/ServicesPage'
import IFSPage from '@/pages/IFSPage'
import CoachingVsTherapyPage from '@/pages/CoachingVsTherapyPage'
import BlogPage from '@/pages/BlogPage'
import BlogPostPage from '@/pages/BlogPostPage'
import ContactPage from '@/pages/ContactPage'
import ResourcesPage from '@/pages/ResourcesPage'
import IFSCoachingCAPage from '@/pages/IFSCoachingCAPage'
import CareerCoachingCAPage from '@/pages/CareerCoachingCAPage'
import SelfDevelopmentCAPage from '@/pages/SelfDevelopmentCAPage'
import ModelsFrameworksPage from '@/pages/ModelsFrameworksPage'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="ifs" element={<IFSPage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="coaching-vs-therapy" element={<CoachingVsTherapyPage />} />
        <Route path="blog" element={<BlogPage />} />
        <Route path="blog/:slug" element={<BlogPostPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="resources" element={<ResourcesPage />} />
        <Route path="ifs-coaching-california" element={<IFSCoachingCAPage />} />
        <Route path="career-coaching-california" element={<CareerCoachingCAPage />} />
        <Route path="self-development-coaching-california" element={<SelfDevelopmentCAPage />} />
        <Route path="models-frameworks" element={<ModelsFrameworksPage />} />
      </Route>
    </Routes>
  )
}
